import React, { useContext, useEffect, useState } from 'react';
import './AccountInfoPage.css';
import { AuthenticationContext } from '../../contexts/AuthenticationProvider';
import ReviewInfoBox from '../../components/ReviewInfoBox/ReviewInfoBox';
import './AccountInfoPage.css';
import { getCustomerInfo, updateCustomer } from '../../services/customerService';
import { getWithExpiry } from '../../services/localStorageService';
import { CUSTOMER_ID } from '../../config';
import OrdersList from '../../components/OrdersList/OrdersList';
import { getOrderYears } from '../../services/orderService';
import Switch from 'react-switch';
import EditGreetingModal from '../../components/EditGreetingModal/EditGreetingModal';
import { Button } from 'semantic-ui-react';
import { CartContext } from '../../contexts/CartProvider';

const AccountInfoPage = (props) => {
  const { setShowSubheader, setShowCart } = useContext(AuthenticationContext);
  const [accountInfo, setAccountInfo] = useState({});
  const [tab, setTab] = useState('profile');
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [reciprocationFlag, setReciprocationFlag] = useState(false);
  const [defaultGreeting, setDefaultGreeting] = useState('');
  const [greetingSuffix, setGreetingSuffix] = useState(0);
  const [greetingSuffixes, setGreetingSuffixes] = useState(['', '']);
  const [editGreetingOpen, setEditGreetingOpen] = useState(false);
  const { setDefaultGreeting: setCtxDefaultGreeting, setGreetingSuffix: setCtxGreetingSuffix } = useContext(CartContext);

  const getCustomer = async () => {
    const info = await getCustomerInfo(getWithExpiry(CUSTOMER_ID));
    setAccountInfo(info || {});
    setReciprocationFlag(Boolean(info?.reciprocation));
    setDefaultGreeting(info?.defaultGreeting || '');
    setGreetingSuffix(info?.greetingSuffix || 0);
    setGreetingSuffixes(info?.greetingSuffixes || ['', '']);
    // also update CartContext so other pages see the change immediately
    try {
      if (typeof setCtxDefaultGreeting === 'function') setCtxDefaultGreeting(info?.defaultGreeting || '');
      if (typeof setCtxGreetingSuffix === 'function') setCtxGreetingSuffix(info?.greetingSuffix || 0);
    } catch (e) {
      // ignore if context not available
    }
  };

  const handlePrintOrders = () => {
    const printWindow = window.open('', '', 'height=600,width=800');
    const table = document.querySelector('.orders-table');
    
    if (table && printWindow) {
      // Extract just the recipient column from the table
      const rows = table.querySelectorAll('tbody tr');
      let recipientRows = '<thead><tr><th>Recipient</th></tr></thead><tbody>';
      
      // Add header
      const header = table.querySelector('thead tr');
      if (header) {
        const firstCell = header.querySelector('th');
        if (firstCell) {
          recipientRows = `<thead><tr><th>${firstCell.textContent}</th></tr></thead><tbody>`;
        }
      }
      
      // Add body rows with just first cell
      rows.forEach((row) => {
        const firstCell = row.querySelector('td');
        if (firstCell) {
          recipientRows += `<tr><td>${firstCell.textContent}</td></tr>`;
        }
      });
      
      recipientRows += '</tbody>';
      
      printWindow.document.write('<html><head><title>Orders</title>');
      printWindow.document.write('<style>');
      printWindow.document.write(`
        body { font-family: Arial, sans-serif; margin: 20px; }
        h2 { margin-bottom: 20px; }
        table { width: 100%; border-collapse: collapse; }
        th, td { border: 1px solid #ddd; padding: 12px; text-align: left; }
        th { background-color: #284b8b; color: white; }
        tr:nth-child(even) { background-color: #f9f9f9; }
      `);
      printWindow.document.write('</style></head><body>');
      printWindow.document.write('<h2>Orders for ' + selectedYear + '</h2>');
      printWindow.document.write('<table>' + recipientRows + '</table>');
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      setTimeout(() => printWindow.print(), 100);
    }
  };

  useEffect(() => {
    setShowSubheader(false);
    setShowCart(true);
    getCustomer();
  }, [setShowSubheader, setShowCart]);

  useEffect(() => {
    let mounted = true;
    const loadYears = async () => {
      try {
        const ys = await getOrderYears();
        if (mounted) setYears(ys || []);
      } catch (e) {
        if (mounted) setYears([]);
      }
    };
    loadYears();
    return () => (mounted = false);
  }, []);

  return (
    <div className="account-info-page">
      <div className="account-dashboard">
        <div className="account-left">
          <div
            className={`menu-item ${tab === 'profile' ? 'active' : ''}`}
            onClick={() => setTab('profile')}
          >
            Profile
          </div>
          <div
            className={`menu-item ${tab === 'orders' ? 'active' : ''}`}
            onClick={() => setTab('orders')}
          >
            Orders
          </div>
          <div
            className={`menu-item ${tab === 'settings' ? 'active' : ''}`}
            onClick={() => setTab('settings')}
          >
            Settings
          </div>
        </div>
        <div className="account-main">
          {tab === 'profile' && (
            <div>
              <h1>Account Information</h1>
              <ReviewInfoBox accountInfo={accountInfo} email={accountInfo.email} />
            </div>
          )}

          {tab === 'orders' && (
            <div>
              <h1>Orders</h1>
              <div className="orders-header">
                <div className="years-list">
                  {years && years.length > 0 ? (
                    years.map((y) => (
                      <div
                        key={y}
                        className={`year-pill ${selectedYear === y ? 'selected' : ''}`}
                        onClick={() => setSelectedYear(y)}
                      >
                        {y}
                      </div>
                    ))
                  ) : (
                    <div>No available years</div>
                  )}
                </div>
                <button
                  className="print-button"
                  onClick={handlePrintOrders}
                  disabled={!selectedYear}
                  title="Print orders for the selected year"
                >
                  🖨️ Print Orders
                </button>
              </div>

              <div className="orders-print-container">
                <OrdersList year={selectedYear} />
              </div>
            </div>
          )}

          {tab === 'settings' && (
            <div>
              <h1>Settings</h1>
              <div className="settings-section">
                <div className="settings-item">
                  <div className="settings-label">Greeting</div>
                  <div className="settings-description">
                    Set your default greeting that will be used for all your recipients.
                  </div>
                  <div className="settings-greeting">
                    <div className="greeting-preview">
                      {defaultGreeting}
                      &nbsp;
                      {greetingSuffixes[greetingSuffix]}
                    </div>
                    <Button
                      primary
                      onClick={() => setEditGreetingOpen(true)}
                    >
                      Edit Greeting
                    </Button>
                  </div>
                </div>

                <div className="settings-item">
                  <div className="settings-label">Reciprocity</div>
                  <div className="settings-description">
                    Turning on reciprocity will automatically ensure that anyone sending to
                    you receives your recognition. Automatically add any names to your list if
                    you have been added to theirs. A second charge for reciprocity will run at
                    the close of the program with an email receipt.
                  </div>
                  <div className="settings-toggle">
                    <label>
                      <Switch
                        height={20}
                        width={40}
                        checked={reciprocationFlag}
                        onChange={async (checked) => {
                          setReciprocationFlag(checked);
                          // update customer with new reciprocation setting
                          await updateCustomer({
                            reciprocation: checked,
                          });
                        }}
                      />
                      <span className="toggle-label">Reciprocity is {reciprocationFlag ? 'On' : 'Off'}</span>
                    </label>
                  </div>
                </div>
              </div>

              <EditGreetingModal 
                open={editGreetingOpen} 
                toggleOpen={() => setEditGreetingOpen(!editGreetingOpen)}
                defaultGreeting={defaultGreeting}
                greetingSuffix={greetingSuffix}
                greetingSuffixes={greetingSuffixes}
                onSave={async (greetingText, suffixIndex) => {
                  // update local state
                  setDefaultGreeting(greetingText);
                  setGreetingSuffix(suffixIndex);
                  // update CartContext so other pages (review) see change immediately
                  try {
                    if (typeof setCtxDefaultGreeting === 'function') setCtxDefaultGreeting(greetingText);
                    if (typeof setCtxGreetingSuffix === 'function') setCtxGreetingSuffix(suffixIndex);
                  } catch (e) {
                    // ignore
                  }
                  // persist both fields in a single PUT
                  await updateCustomer({
                    defaultGreeting: greetingText,
                    greetingSuffix: suffixIndex,
                  });
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccountInfoPage;